import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Logo from '../components/Logo';
import './LoginPage.css';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated } = useAuth();

  // Check if user is already logged in
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const success = await login(email, password);
      
      if (success) {
        // Redirect to intended page or home
        const from = location.state?.from?.pathname || '/';
          navigate(from, { replace: true });
      } else {
        setError('Invalid credentials. Please try again.');
      }
    } catch (error: any) {
      const errorMessage = error?.message || 'An error occurred during login';
      
      if (errorMessage.includes('Cannot connect to server') || 
          errorMessage.includes('Network request failed')) {
        setError('Cannot connect to the server. Please check your connection and try again.');
      } else if (errorMessage.includes('Invalid') || errorMessage.includes('credentials')) {
        setError('Invalid email or password. Please try again.');
      } else {
        setError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-content">
        <div className="login-header-section">
          <Logo size="large" variant="default" showTagline={true} />
          <p className="login-subtitle">Welcome Back!</p>
        </div>

        <div className="login-form-card">
        {error && (
          <div className="alert alert-error">
            <span className="alert-icon">⚠️</span>
            {error}
          </div>
        )}

            <form onSubmit={handleLogin} className="login-form">
                <input
                  type="email"
              className="login-input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoCapitalize="none"
              autoComplete="email"
                  required
                />
                <input
                  type="password"
              className="login-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
                  required
            />

            <button 
              type="submit" 
              className="login-button" 
              disabled={loading}
            >
              {loading ? (
                <span className="login-button-loading">
                  <span className="spinner"></span>
                  Signing In...
                </span>
              ) : (
                'Login'
              )}
              </button>

            <div className="login-link-section">
              <Link to="/register" className="login-link">
                Don't have an account? <span className="login-link-bold">Sign Up</span>
              </Link>
          </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
